import { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';
import { MHighlightIconAlignment } from '../../molecules/MHighlightIcon/MHighlightIcon.types';
import { MHighlightNumericAlignment } from '../../molecules/MHighlightNumeric/MHighlightNumeric.types';
import { AIconProps } from '../../atoms/AIcon/AIcon.types';
import { ABodyProps } from '../../atoms/ABody/ABody.types';
import { ADigitProps } from '../../atoms/ADigit/ADigit.types';
import { MHighlightTextAlignment } from '../../molecules/MHighlightText/MHighlightText.types';
import { AAccentLineProps } from '../../atoms/AAccentLine/AAccentLine.types';

export enum OHighlightType {
  Icon = 'Icon',
  Numeric = 'Numeric',
  Text = 'Text',
}

export enum OHighlightContentAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export type OHighlightProps = {
  componentId: string;
  type: OHighlightType;
  styleclass?: string | null;
  mHighlightIcons?: OHighlightIconItem[];
  mHighlightNumerics?: OHighlightNumericItem[];
  mHighlightTexts?: OHighlightTextItem[];
  trackingProperties?: Record<string, unknown>;
};

export interface OHighlightButton {
  buttonText?: string | null;
  size?: string | null;
  type?: string | null;
  ctaLink?: string | null;
  openInANewTab?: string | null;
}

export interface OHighlightIconItem {
  alignment?: MHighlightIconAlignment;
  aBody?: ABodyProps;
  aIcon?: AIconProps;
  aSubheader?: ASubheaderProps;
  mButton?: OHighlightButton;
}

export interface OHighlightNumericItem {
  alignment?: MHighlightNumericAlignment;
  aBody: ABodyProps;
  aDigit: ADigitProps;
  mButton?: OHighlightButton;
}

export interface OHighlightTextItem {
  alignment?: MHighlightTextAlignment;
  aBody?: ABodyProps;
  aAccentLine?: AAccentLineProps;
  aSubheader?: ASubheaderProps;
  mButton?: OHighlightButton;
}
